<template>
    <nav aria-label="breadcrumb" class="modern-breadcrumb mb-4">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="item in items" :key="item.id" @click="navigateTo(item)">
                <a href="#" class="breadcrumb-link">
                    <i v-if="item.icon" :class="`bi bi-${item.icon} me-1`"></i>
                    {{ item.title }}
                </a>
                <i class="bi bi-chevron-right separator"></i>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                <span class="current-page">{{currentPage}}</span>
            </li>
        </ol>
    </nav>
</template>
    
<script>
export default {
    name: 'BreadcrumbElement',
    emits: ['change-view'],
    props: {
        items: {
            type: Array,
            required: true
        },
        currentPage: {
            type: String,
            required: true
        }
    },
    methods: {
        navigateTo(item) {
            // Usiamo l'emit standard di Vue, seguendo lo stesso pattern di Sidebar
            this.$emit('change-view', item);
        }
    }
}
</script>

<style scoped>
.modern-breadcrumb {
    background-color: transparent;
    padding: 0.5rem 0;
}

.breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding: 0;
}

.breadcrumb-item {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    position: relative;
}

.breadcrumb-link {
    color: #6c757d;
    text-decoration: none;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-weight: 500;
}

.breadcrumb-link:hover {
    color: #0d6efd;
    background-color: rgba(74, 108, 247, 0.05);
}

.separator {
    color: #ced4da;
    font-size: 0.75rem;
    margin: 0 0.25rem;
}

.breadcrumb-item:last-child .separator {
    display: none;
}

.breadcrumb-item.active {
    color: #495057;
}

.current-page {
    font-weight: 600;
    color: #495057;
    padding: 0.25rem 0.5rem;
}
</style>